module.exports = __webpack_public_path__ + "assets/img/album-carousel-alt-thumb.3725e614.png";